import {
  SPARE_INVENTORY_GMDS_CODE_FILTER,
  SPARE_INVENTORY_ITEM_DESCRIPTION_FILTER,
  SPARE_INVENTORY_CREATED_BY_FILTER,
  SPARE_INVENTORY_ITEM_LOCATION_FILTER,
} from "../../custom/Utils/ListFilterOptions";

const schema = localStorage.getItem("schema");
export const basicFormData = () => ({
  inputData: {
    material_id: "",
    quantity: "",
    alert_qty: "",
    item_location: "",
    created_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "inverts",
    schema: schema,
    include: [
      {
        model: "material_masters",
        as: "material",
        include: [{ model: "inventories", as: "inventory" }],
      },
    ]
  };

  const navigatePage = { back: "/spare-part-inventory-list" };

  const headerName = "Spare Part Inventory";

  const validationType = "SparePartInventoryCreate";
  const endpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    endpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "inverts",
    schema: schema,
    include: [
      {
        model: "material_masters",
        as: "material",
        include: [{ model: "inventories", as: "inventory" }],
      },
      {
        model: "user_masters",
        as: "createdByUser",
      },
    ]
  };


  const navigatePage = {
    create: "/spare-part-inventory-create",
    edit: "/spare-part-inventory-create",
    view: "/spare-part-inventory-view",
  };

  const searchfields = [
    "material.gmds_code",
    "item_location",
  ];

  const filterConfig = [
    SPARE_INVENTORY_ITEM_DESCRIPTION_FILTER,
    SPARE_INVENTORY_GMDS_CODE_FILTER,
    SPARE_INVENTORY_CREATED_BY_FILTER,
    SPARE_INVENTORY_ITEM_LOCATION_FILTER,
  ];

  const headerName = "Spare Part Inventory";
  const endpoint = "/getRecords";
  const exportFileName = "SparePartInventoryData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    endpoint,
    searchfields,
    exportFileName,
    filterConfig,
  };
};

export const exportPageData = {
  modelName: "inverts",
  schema: schema,
  include: [
    {
      model: "material_masters",
      as: "material",
      include: [{ model: "inventories", as: "inventory" }],
    },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
